import { useFormContext } from '@/lib/form.ts';
import { useBlocker } from '@tanstack/react-router';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Trans } from '@lingui/react/macro';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

export const FormNavigationBlocker = () => {
  const form = useFormContext();

  const { proceed, reset, status } = useBlocker({
    shouldBlockFn: () => form.state.isDirty,
    enableBeforeUnload: () => form.state.isDirty,
    withResolver: true,
  });

  return (
    <Dialog open={status === 'blocked'} onClose={reset}>
      <DialogTitle>
        <Trans>You have unsaved changes</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans>
            You are about to leave a form with unsaved changes. These changes will be lost. Do you
            really want to proceed?
          </Trans>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={reset}>
          <Trans>Stay on this page</Trans>
        </Button>
        <Button onClick={proceed} color="primary" variant="contained">
          <Trans>Proceed</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
